import {
    ApiQuery,
    FilterOperators,
    SortDirections,
} from "~/modules/filters/types";
import { ManagerColumns } from ".";

// // // //

/**
 * DEFAULT_MANAGER_LIST_QUERY
 * Default ApiQuery for ServiceProvider list
 */
export const DEFAULT_MANAGER_LIST_QUERY: ApiQuery = {
    filter: {
        field: ManagerColumns.assetCount,
        operator: FilterOperators.GreaterThan,
        value: 0,
    },
    sort: {
        direction: SortDirections.asc,
        field: ManagerColumns.name,
    },
    pagination: {
        page: 1,
        perPage: 25,
    },
};
